/**
 * Converts a Vimeo or YouTube URL to an embeddable iframe URL
 */
export function getEmbedUrl(url: string): string | null {
  if (!url) return null;

  // YouTube patterns
  const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
  const youtubeMatch = url.match(youtubeRegex);
  if (youtubeMatch) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}?enablejsapi=1`;
  }

  // Vimeo patterns - handles both regular and privacy hash URLs
  // Format: https://vimeo.com/VIDEO_ID or https://vimeo.com/VIDEO_ID/HASH
  const vimeoRegex = /vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-zA-Z0-9]+))?/;
  const vimeoMatch = url.match(vimeoRegex);
  if (vimeoMatch) {
    const videoId = vimeoMatch[1];
    const hash = vimeoMatch[2];
    
    if (hash) {
      return `https://player.vimeo.com/video/${videoId}?h=${hash}`;
    }
    return `https://player.vimeo.com/video/${videoId}`;
  }

  // If it looks like a direct video URL (.mp4, .webm, etc.), return it as is
  if (/\.(mp4|webm|ogg)$/i.test(url)) {
    return url;
  }

  return null;
}

/**
 * Checks if a URL is a direct video file
 */
export function isDirectVideoUrl(url: string): boolean {
  return /\.(mp4|webm|ogg)$/i.test(url);
}

/**
 * Checks if a URL is an external video service (YouTube, Vimeo)
 */
export function isExternalVideo(url: string): boolean {
  return /(?:youtube\.com|youtu\.be|vimeo\.com)/i.test(url);
}

/**
 * Checks if a URL is a Vimeo video
 */
export function isVimeoUrl(url: string): boolean {
  return /vimeo\.com/i.test(url);
}
